
    import '/opt/buildhome/repo/packages/x/docs/playground/independent.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-playground-independent-demo-independent"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/playground/independent.en-US.md?type=demo')
};